// Fixed ORDER-gear + SHAPE categorization for the nav drawer's dropdown
// sections. Independent of the user-editable Settings → Sidebar groups
// (sidebar_groups jsonb) — those remain a separate, freeform feature. This
// mapping is the deity roster from docs/OLMPS_V9_SPEC.md §5/§7 and
// ascension.ts's GEAR_TIERS, renamed to the drawer's section labels
// (Orient → "Objectives", Direct → "Directions"). HRMEZ and NEMOS are OLMPN
// seats *and* SHAPE sector deities (V9 §7), so they intentionally appear
// in two sections.

export interface SidebarGearGroup {
  key: string;
  label: string;
  toolIds: string[];
}

export const SIDEBAR_GEAR_GROUPS: SidebarGearGroup[] = [
  // ORIENT is one tool (ATLAS). The retired ids stay grouped here so any saved
  // sidebar item for them is absorbed into this section instead of leaking out.
  { key: 'objectives', label: 'Objectives', toolIds: ['atlas', 'oracle', 'telos', 'astra', 'astrs'] },
  { key: 'regulate', label: 'Regulate', toolIds: ['poros', 'numa', 'moyri', 'hrmez'] },
  { key: 'directions', label: 'Directions', toolIds: ['kyrs', 'krnos', 'tkne'] },
  { key: 'execute', label: 'Execute', toolIds: ['metis', 'themis', 'jnus'] },
  { key: 'revise', label: 'Revise', toolIds: ['clio', 'argos', 'nemos', 'epic'] },
  { key: 'shape', label: 'SHAPE', toolIds: ['sofia', 'hygia', 'hypnos', 'akeso', 'plutus', 'hrmez', 'nemos'] },
];
